import React, { useEffect } from "react";
import { Verified } from "@mui/icons-material";
import { aboutTexts } from "../mock/AboutData";

const AboutSection = () => {
  const handleScrollToContact = () => {
    const contactSection = document.getElementById("contact");
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      className="scroll-mt-24 py-12 bg-gradient-to-br from-black via-purple-900 to-black text-white relative"
      id="about"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        {/* Texto a la derecha */}
        <div className="text-center lg:text-left">
          <h2
            data-aos="fade-up"
            className="text-4xl md:text-5xl font-bold mb-6 leading-tight bg-gradient-to-r from-pink-500 via-yellow-300 to-purple-400 bg-clip-text text-transparent"
          >
            ¿Por qué elegir a Viajechinaconlulu?
          </h2>

          <ul className="space-y-4 mb-8">
            {aboutTexts.map((text, index) => (
              <li
                key={index}
                data-aos="fade-up"
                data-aos-delay={100 + index * 50}
                className="flex items-start gap-3 text-left text-gray-300 text-lg md:text-xl"
              >
                <Verified className="text-blue-400 min-w-[1.5rem]" size={24} />
                <span>{text}</span>
              </li>
            ))}
          </ul>
        </div>
        {/* Imagen o Video a la izquierda */}
        <div data-aos="fade-right" className="w-full h-full">
          <div className="h-full min-h-[520px] rounded-2xl overflow-hidden shadow-lg shadow-blue-500/30 border border-purple-800 flex items-center">
            {/* Imagen por defecto */}
            <img
              src="https://res.cloudinary.com/ddx3pzjlm/image/upload/v1751594612/logo3_fuhdyx.png"
              alt="Proyecto"
              className="w-full h-full object-cover"
            />

            {/*
            // Si deseas usar un video en lugar de imagen, comenta <img> y descomenta esto:

            <video
              src="https://res.cloudinary.com/demo/video/upload/w_800/v1680000000/sample.mp4"
              autoPlay
              loop
              muted
              playsInline
              className="w-full h-full object-cover"
            />
            */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
